import { AxiosResponse } from 'axios';

import { API_BASE_PATH } from '@/config';
import { axios } from '@/lib/axios';

export const downloadTimeOffRequestsXLS = (
  page?: string,
  sort?: string,
  type?: string,
  createdBetween?: string
): Promise<AxiosResponse<Blob, any>> =>
  axios.get(`${API_BASE_PATH}/workers/time-off`, {
    params: {
      sort,
      page,
      'filter[createdBetween]': createdBetween,
      'filter[type]': type,
      'filter[status]': 'submitted',
    },
    headers: {
      accept: 'application/octet-stream',
    },
    responseType: 'blob',
  });
